module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc8",
      "id": "dd8"
    }
  }, [_c('i', [_vm._v("January 6")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "amJanuary6"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0011-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("Let the beauty of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" our God be upon us, and establish the work of our hands for us")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0011-04-4"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("Y")]), _vm._v("our beauty . . . was perfect through My splendor which I had bestowed on you,” says the Lord G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(". • We all, with unveiled face, beholding as in a mirror the glory of the Lord, are being transformed into the same image from glory to glory, just as by the Spirit of the Lord. • The Spirit of glory and of God rests upon you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-05-7"
    }
  }, [_vm._v("Blessed is every one who fears the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", who walks in His ways. When you eat the labor of your hands, you shall be happy, and it shall be well with you. • Commit your works to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", and your thoughts will be established.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-05-8"
    }
  }, [_vm._v("Work out your own salvation with fear and trembling; for it is God who works in you both to will and to do for His good pleasure. • Our Lord Jesus Christ Himself, and our God and Father, who has loved us and given us everlasting consolation and good hope by grace, comfort your hearts and establish you in every good word and work.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 90:17; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ZEK")]), _vm._v(". 16:14; 2 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(". 3:18; 1 P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER")]), _vm._v(" 4:14; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 128:1–2; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROV")]), _vm._v(". 16:3; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIL")]), _vm._v(". 2:12–13; 2 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HESS")]), _vm._v(". 2:16–17")]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "aeJanuary6"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0011-08-12"
    }
  }, [_c('span', [_c('i', [_vm._v("The apostles gathered to Jesus and told Him all . . . they had done")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0011-09-14"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("T")]), _vm._v("here is a friend who sticks closer than a brother. • The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" spoke to Moses face to face, as a man speaks to his friend. • You are My friends if you do whatever I command you. No longer do I call you servants, for a servant does not know what his master is doing; but I have called you friends, for all things that I heard from My Father I have made known to you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-10-17"
    }
  }, [_vm._v("So likewise you, when you have done all those things which you are commanded, say, “We are unprofitable servants. We have done what was our duty to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-10-18"
    }
  }, [_vm._v("For you did not receive the spirit of bondage again to fear, but you received the Spirit of adoption by whom we cry out, “Abba, Father.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-10-19"
    }
  }, [_vm._v("Be anxious for nothing, but in everything by prayer and supplication, with thanksgiving, let your requests be made known to God. • The prayer of the upright is His delight.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARK")]), _vm._v(" 6:30; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROV")]), _vm._v(". 18:24; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("X")]), _vm._v(". 33:11; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 15:14–15; L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKE")]), _vm._v(" 17:10; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OM")]), _vm._v(". 8:15; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIL")]), _vm._v(". 4:6; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROV")]), _vm._v(". 15:8")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-373b8960","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter8.vue
// module id = 87
// module chunks = 0